// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1-iQt","actions":"Header_actions__2JWC2"};